<app-menu *ngIf="cmsMenu$ | async as cmsMenu" [menu]="cmsMenu"></app-menu>
